import React, { useState, useEffect } from "react";
import {
  Container,
  VStack,
  HStack,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Button,
  Center,
  Alert,
  AlertIcon,
  Flex,
  Box,
  useBreakpointValue,
  Icon,
  PinInput,
  PinInputField,
  InputGroup,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { useToast, useColorModeValue } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import {
  generateOtpForPasswordReset,
  validateOtpForPasswordReset,
  resetPasswordForStudent,
} from "./forgotPasswordApi";
import { ReactComponent as LynxSplash } from "../../res/lynx_spash.svg"; // Assuming the SVG is available at this path
import {
  useGoogleReCaptcha,
  GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";
import { MdError, MdCheckCircle } from "react-icons/md";
import { color } from "framer-motion";
const ForgotPassword = () => {
  const [rollNo, setrollNo] = useState("");
  const [otp, setOtp] = useState("");
  const [new_password, setnew_password] = useState("");
  const [new_cpassword, setnew_cpassword] = useState("");
  const [step, setStep] = useState(1); // Step 1: RollNo, Step 2: OTP, Step 3: New Password
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const toast = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [showOtp, setshowOtp] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const splashRender = useBreakpointValue({ base: false, lg: true }); // To conditionally render image
  const handleOtpChange = (value) => {
    // console.log(value);
    setOtp(value);
  };
  const handleView = () => {
    setshowOtp(!showOtp);
  };
  const bgColor = useColorModeValue("#1a202b", "#5a5d63"); // light mode: gray.200, dark mode: gray.700
  const textColor = useColorModeValue("white", "white");
  const handleClickPassword = () => setShowPassword(!showPassword);
  const handleClickConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const showToast = (title, description, status) => {
    toast({
      title,
      description,
      status,
      duration: 3000,
      isClosable: true,
      position: "bottom",
      render: ({ onClose }) => (
        <Box
          color="white"
          p={0.5}
          bg={status === "error" ? "red.600" : "green.600"}
          borderRadius="md"
          boxShadow="md"
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-evenly"
          mb={4}
          mx={4}
        >
          <Icon
            as={status === "error" ? MdError : MdCheckCircle}
            w={5}
            h={5}
            color="white"
          />

          <Flex flexDirection="row" justifyContent="left" alignItems="center">
            <Text fontWeight="bold" flex="1" textAlign={"left"} ml="1">
              {title}
            </Text>
            <Text
              color="white"
              fontWeight="sm"
              ml="1"
              textAlign={"center"}
              flexWrap={"wrap"}
            >
              {description}
            </Text>
          </Flex>
          <Button
            size="sm"
            ml={2}
            colorScheme={status === "error" ? "red" : "green"}
            variant="outline"
            color={status === "error" ? "white" : "black"}
            _hover={{
              color: status === "error" ? "black" : "white",
            }}
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      ),
    });
  };

  const handleGenerateOtp = async () => {
    try {
      if (!rollNo) {
        showToast("Error", "Enter Roll No", "error");
        return;
      }
      if (!executeRecaptcha) {
        showToast("Error", "Otp generation failed", "error");
        return;
      }

      const reCaptchaToken = await executeRecaptcha();
      if (!reCaptchaToken) {
        showToast("Error", "Otp generation failed", "error");
        return;
      }
      await generateOtpForPasswordReset(rollNo, reCaptchaToken);
      setStep(2);
      showToast("OTP Sent", "OTP sent successfully!", "success");
    } catch (error) {
      showToast("Error", "refresh and try again!", "error");
      console.log(error);
    }
  };

  const handleValidateOtp = async () => {
    try {
      const data = await validateOtpForPasswordReset(rollNo, otp);
      setToken(data.token);
      setStep(3);
      showToast("OTP Validated", "Enter your new password.", "success");
    } catch (error) {
      showToast("Error", "Otp Validation Failed", "error");
    }
  };

  const handleResetPassword = async () => {
    try {
      // console.log(new_cpassword);
      if (new_cpassword !== new_password) {
        showToast("Error", "Passwords not matching", "error");
        return;
      }
      await resetPasswordForStudent(rollNo, new_password, token, new_cpassword);
      showToast("Success", "Password Reseted Successfully", "success");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      showToast("Error", "Password Reset Failed", "error");
    }
  };

  return (
    <HStack justify={"center"} spacing={0} h={"100vh"}>
      <Container overflowX={"hidden"} h={"full"} m={0} p={0}>
        <HStack style={{ transition: "1s" }}>
          <Container h="100vh" w="100%" mx={0} px={0}>
            <Center h="full">
              <VStack spacing={12}>
                <VStack spacing={[0.1, 0.5, 1]}>
                  <Heading fontWeight={700}>Forgot Password</Heading>
                  <Text color="gray.500" fontWeight={400} fontSize={"0.85em"}>
                    {step === 1 && "Enter your Roll Number to receive an OTP"}
                    {step === 2 && "Enter the OTP sent to your webmail"}
                    {step === 3 && "Set your new password"}
                  </Text>
                </VStack>
                <VStack spacing={4} w="100%">
                  {step === 1 && (
                    <>
                      <FormControl id="email" isRequired w="full" mx={0}>
                        <FormLabel>Roll No:</FormLabel>
                        <Input
                          type="number"
                          value={rollNo}
                          onChange={(e) => setrollNo(e.target.value)}
                          variant="filled"
                          borderRadius="4px"
                          placeholder="Enter your Roll Number"
                          w="full" // Ensure input is full width
                        />
                      </FormControl>
                      <Button
                        w="full"
                        mx={0}
                        colorScheme="blue"
                        borderRadius="4px"
                        onClick={handleGenerateOtp}
                      >
                        Send OTP
                      </Button>
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <FormControl id="otp" isRequired mx="15%">
                        <FormLabel ml={"1"} mb={"2"}>
                          OTP
                        </FormLabel>
                        <HStack
                          spacing={2}
                          w="100%"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <PinInput
                            type="alphanumeric"
                            mask={showOtp}
                            value={otp}
                            onChange={handleOtpChange}
                            w={{ base: "80%", sm: "85%" }}
                          >
                            {[...Array(6)].map((_, index) => (
                              <PinInputField
                                key={index}
                                w="16%"
                                h={{ base: "32px", sm: "40px" }}
                                borderRadius={5}
                                bg={bgColor}
                                color={textColor}
                                textAlign="center"
                                fontSize={{ base: "md", sm: "lg" }}
                              />
                            ))}
                          </PinInput>
                          <Box
                            w={{ base: "20%", sm: "15%" }}
                            display="flex"
                            justifyContent="flex-end"
                          >
                            <IconButton
                              aria-label={
                                showOtp ? "Show Password" : "Hide Password"
                              }
                              icon={showOtp ? <ViewIcon /> : <ViewOffIcon />}
                              size={{ base: "sm", sm: "md" }}
                              h={{ base: "32px", sm: "40px" }}
                              w={{ base: "32px", sm: "40px" }}
                              onClick={handleView}
                            />
                          </Box>
                        </HStack>

                        <Button
                          w="100%"
                          colorScheme="blue"
                          borderRadius="4px"
                          onClick={handleValidateOtp}
                          mt={4}
                        >
                          Validate OTP
                        </Button>
                      </FormControl>
                    </>
                  )}
                  {step === 3 && (
                    <>
                      <form onSubmit={(e) => e.preventDefault()}>
                        <VStack spacing={4} align="stretch">
                          <FormControl isRequired>
                            <FormLabel htmlFor="new-password">
                              New Password
                            </FormLabel>
                            <InputGroup size="md">
                              <Input
                                id="new-password"
                                type={showPassword ? "text" : "password"}
                                value={new_password}
                                onChange={(e) =>
                                  setnew_password(e.target.value)
                                }
                                variant="filled"
                                borderRadius="4px"
                                placeholder="Enter your new password"
                                className="password-input"
                                autoComplete="new-password"
                              />
                              <InputRightElement width="3rem">
                                {showPassword ? (
                                  <ViewOffIcon
                                    onClick={handleClickPassword}
                                    cursor="pointer"
                                  />
                                ) : (
                                  <ViewIcon
                                    onClick={handleClickPassword}
                                    cursor="pointer"
                                  />
                                )}
                              </InputRightElement>
                            </InputGroup>
                          </FormControl>

                          <FormControl isRequired>
                            <FormLabel htmlFor="confirm-password">
                              Confirm Password
                            </FormLabel>
                            <InputGroup size="md">
                              <Input
                                id="confirm-password"
                                type={showConfirmPassword ? "text" : "password"}
                                value={new_cpassword}
                                onChange={(e) =>
                                  setnew_cpassword(e.target.value)
                                }
                                variant="filled"
                                borderRadius="4px"
                                placeholder="Confirm password"
                                className="passwordconfirm-input"
                                autoComplete="new-password"
                              />
                              <InputRightElement width="3rem">
                                {showConfirmPassword ? (
                                  <ViewOffIcon
                                    onClick={handleClickConfirmPassword}
                                    cursor="pointer"
                                  />
                                ) : (
                                  <ViewIcon
                                    onClick={handleClickConfirmPassword}
                                    cursor="pointer"
                                  />
                                )}
                              </InputRightElement>
                            </InputGroup>
                          </FormControl>
                        </VStack>
                      </form>
                      <Button
                        w="full"
                        colorScheme="blue"
                        borderRadius="4px"
                        onClick={handleResetPassword}
                      >
                        Reset Password
                      </Button>
                    </>
                  )}
                  <Button
                    variant="ghost"
                    borderRadius="4px"
                    onClick={() => navigate("/login")}
                    width="80%"
                  >
                    Back to Login
                  </Button>
                </VStack>
              </VStack>
            </Center>
          </Container>
        </HStack>
      </Container>
      {splashRender && (
        <Center h={"full"} m={0} p={0}>
          <LynxSplash style={{ height: "90%" }} />
        </Center>
      )}
    </HStack>
  );
};

export default ForgotPassword;
